export const data = [
  {
    id: "1",
    date: "13 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
  {
    id: "2",
    date: "12 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
  {
    id: "3",
    date: "11 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
  {
    id: "4",
    date: "10 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
  {
    id: "5",
    date: "9 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
  {
    id: "6",
    date: "8 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
  {
    id: "7",
    date: "7 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
  {
    id: "8",
    date: "6 Apr 2020",
    orderId: "123456",
    type: "Sale",
    title: "Course Title Here",
    amount: "10",
    fee: "5",
  },
];
